import { type FC } from 'react';
import loadable from '@loadable/component';
import { useServerContext } from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import { Layout } from '../../components/layout/Layout';
import Seo from '../../components/seo';
import { useIsMobile } from '../../hooks/use-is-mobile';
import { isNoIndexPage } from '../../utils/is-no-index-page';
import { isServer } from '../../utils/utils';
import { configHtmlCache } from '../utils/config-html-cache';
import { SearchSkeletons } from './components/skeletons/SearchSkeletons';
import { useSearches } from './hooks/use-search/useSearches';

const Search = loadable(() => import('./Search'));

interface SearchProps {
    location?: Location;
}

export const SearchLazy: FC<SearchProps> = () => {
    const intl = useIntl();
    const location = useLocation();
    const serverContext = useServerContext();
    if (isServer && serverContext) {
        configHtmlCache(serverContext.res);
    }
    const { totalResults } = useSearches();
    const isMobile = useIsMobile();

    const query = new URLSearchParams(location?.search).get('q');
    let title = intl.formatMessage(
        {
            id: 'search.results.for',
            defaultMessage: 'Search Results For {query}',
        },
        { query },
    );
    if (!totalResults) {
        title = query
            ? intl.formatMessage(
                  {
                      id: 'no.search.results.for',
                      defaultMessage: 'No Search Results for {query}',
                  },
                  { query },
              )
            : intl.formatMessage({
                  id: 'no.search.results',
                  defaultMessage: 'No Search Results for "undefined"',
              });
    }

    return (
        <Layout stickyNavigation={isMobile}>
            <Seo title={title} noIndex={isNoIndexPage(location?.pathname)} />
            <Search fallback={<SearchSkeletons />} />
        </Layout>
    );
};
